import React, { useState } from "react";
import "../styles/weekly-nutrition.scss";
import OrangeSeperator from "./OrangeSeperator";
import Chart from "./sub_components/Chart";

const WeeklyNutrition = () => {
  const [displayedNutrient, setDisplayedNutrient] = useState("calories");

  // Handles button styles
  const handleButtonStyles = (nutrient) => {
    if (nutrient === displayedNutrient) {
      return "weekly-nutrition__button weekly-nutrition__button--active";
    } else {
      return "weekly-nutrition__button";
    }
  };

  return (
    <div className="weekly-nutrition">
      <header className="weekly-nutrition__header">
        <h3 className="weekly-nutrition__title">Weekly Nutrition</h3>
        <OrangeSeperator />
        <p className="weekly-nutrition__description">
          Here you can see the last 7 days of your nutrition intake status.
        </p>
      </header>
      <div className="weekly-nutrition__content">
        <div className="weekly-nutrition__orange-background">
          <div className="weekly-nutrition__buttons">
            <div className="weekly-nutrition__buttons-1">
              <button
                className={handleButtonStyles("calories")}
                onClick={() => {
                  setDisplayedNutrient("calories");
                }}
              >
                Calories
              </button>
              <button
                className={handleButtonStyles("fat")}
                onClick={() => {
                  setDisplayedNutrient("fat");
                }}
              >
                Fat
              </button>
            </div>
            <div className="weekly-nutrition__buttons-2">
              <button
                className={handleButtonStyles("protein")}
                onClick={() => {
                  setDisplayedNutrient("protein");
                }}
              >
                Protein
              </button>
              <button
                className={handleButtonStyles("carbs")}
                onClick={() => {
                  setDisplayedNutrient("carbs");
                }}
              >
                Carbs
              </button>
            </div>
          </div>
        </div>
        <div className="weekly-nutrition__graph-container">
          <h5 className="weekly-nutrition__graph-title">{displayedNutrient}</h5>
          <div className="weekly-nutrition__graph">
            <Chart displayedNutrient={displayedNutrient} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeeklyNutrition;
